<div class="container">
    <app-loading *ngIf="!Providers"></app-loading>
    <ng-container *ngIf="Providers">
        <div align="center">
            <ng-container *ngIf="providersName;else elseBlock">
                <h1 [ngStyle]="{'color': providersName === 'EVOCABANK' ? '#6400dc' : '' }" class="break-word">{{providersName}}</h1>
            </ng-container>
            <ng-template #elseBlock>
                <h1>{{ 'Title.paymentTitle' | translate }}</h1>
            </ng-template>
        </div>
        <div class="flex-box">
            <ng-container *ngFor="let provider of Providers">
                <div *ngIf="provider.VisibleFromWeb" class="box-3">
                    <app-provider-item [Provider]="provider"></app-provider-item>
                </div>
            </ng-container>
        </div>
    </ng-container>
</div>